export default () => ({
  settings: {
    leftIconSettings: {
      icon  : '',
      event : ''
    },
    textSettings: {
      text      : '',
      textAlign : ''
    },
    rightIconSettings: {
      icon  : '',
      event : [{
        text   : '',
        action : ''
      }]
    }
  },
  eventSelected: ''
});

// Example with icon and action list
// leftIconSettings: {
//   icon: 'mdi-arrow-left',
//   event: 'back-page'
// },
// textSettings: {
//   text: 'Home',
// }
// rightIconSettings: {
//   icon: 'mdi-dots-vertical',
//   event: [{
//     text: 'Apagar',
//     action: 'delete'
//   }, {
//     text: 'Duplicar',
//     action: 'duplicate'
//   }]
// }

// Example with icon and action
// leftIconSettings: {
//   icon: 'mdi-arrow-left',
//   event: 'back-page'
// },
// textSettings: {
//   text: 'Minhas Turmas',
//   textAlign: 'left'
// }
// rightIconSettings: {
//   icon: 'mdi-trash',
//   event: [{
//     text: 'Apagar',
//     action: 'delete'
//   }]
// }
